import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (code, state) => api.post('/auth/callback', { code, state }),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
};

export const answersAPI = {
  getAll: () => api.get('/answers'),
  getById: (id) => api.get(`/answers/${id}`),
  create: (data) => api.post('/answers', data),
  update: (id, data) => api.put(`/answers/${id}`, data),
  delete: (id) => api.delete(`/answers/${id}`),
};

export const allAnswersAPI = {
  getAll: (params) => api.get('/all-answers', { params }),
  getStats: () => api.get('/all-answers/stats'),
};

export const publicAPI = {
  getAnswer: (shortId) => axios.get(`${API_BASE_URL}/public/answer/${shortId}`),
};

export default api;
